export const BOT_OPS_SECTIONS = [
    { id: "operar", label: "Operar" },
    { id: "config", label: "Config" },
    { id: "canal", label: "Canal" },
    { id: "sandbox", label: "Chat" },
    { id: "ajuda", label: "Ajuda" },
    { id: "testes", label: "Testes" },
];

const IDS = new Set(BOT_OPS_SECTIONS.map((s) => s.id));

export function parseBotOpsSection(raw) {
    if (typeof raw === "string" && IDS.has(raw)) return raw;
    return "operar";
}
